var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8636_18774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 45C35.4263 45 45.4999 34.9264 45.4999 22.5C45.4999 10.0736 35.4263 0 22.9999 0C10.5735 0 0.499878 10.0736 0.499878 22.5C0.499878 34.9264 10.5735 45 22.9999 45Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.1249,
    cy: 22.5,
    r: 2.9375,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.9999,
    cy: 22.5,
    r: 2.9375,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.8749,
    cy: 22.5,
    r: 2.9375,
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8636_18774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.499878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.a4232c5cb153105588699804fb2a1a46.svg";
export { ForwardRef as ReactComponent };